export default __webpack_public_path__ + "static/BALPPA-c9889722b9d4f83870f2862c7cd15f38.png";